import _get from "lodash/get";
import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { FwaCartState } from "../../../../models/state";
import { fulfilled, pending } from "../../app/utils";

const initialState: FwaCartState = {
    addToCartSuccess: false,
};

const reducer = (state = initialState, action: AnyAction): FwaCartState => {
    switch (action.type) {
        case pending(AT.FWA_ADD_PACKAGE_TO_CART):
            return {
                ...state,
                addToCartSuccess: false,
            };
        case fulfilled(AT.FWA_ADD_PACKAGE_TO_CART):
            return {
                ...state,
                packageId: _get(action, "payload.packageId", ""),
                contentfulPackageId: _get(action, "payload.contentfulPackageId"),
                additionalProducts: _get(action, "payload.additionalProducts", []),
                addToCartSuccess: _get(action, "payload.success", false),
            };
        default:
            return state;
    }
};

export default reducer;
